import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CatProgressIndicator } from "blocks-nextjs/blocks-react/components/ProgressIndicator/ProgressIndicator";
import { CatProgressIndicatorItem } from "blocks-nextjs/blocks-react/components/ProgressIndicatorItem/ProgressIndicatorItem";
import React, { useState } from "react";
import AddEditGeoFenceForm from "../../components/CreateNewProject/AddEditGeoFenceForm";
import NewProjectAddEditAssetsPortfolio from "../../components/CreateNewProject/NewProjectAddEditAssetsPortfolio";
import NewProjectAssetPortfolio from "../../components/CreateNewProject/NewProjectAssetPortfolio";
import NewProjectForm, { ModeType } from "../../components/CreateNewProject/NewProjectForm";
import useAppConfigStore from "../../store/useAppConfigStore";
import useNewProjectStore from "../../store/useNewProjectStore";
export var IndicatorItemsStatus;
(function (IndicatorItemsStatus) {
    IndicatorItemsStatus["active"] = "active";
    IndicatorItemsStatus["complete"] = "complete";
    IndicatorItemsStatus["disabled"] = "disabled";
    IndicatorItemsStatus["incomplete"] = "incomplete";
})(IndicatorItemsStatus || (IndicatorItemsStatus = {}));
export var NewProjectSteps;
(function (NewProjectSteps) {
    NewProjectSteps[NewProjectSteps["STEP_ONE"] = 1] = "STEP_ONE";
    NewProjectSteps[NewProjectSteps["STEP_THREE"] = 3] = "STEP_THREE";
    NewProjectSteps[NewProjectSteps["STEP_TWO"] = 2] = "STEP_TWO";
})(NewProjectSteps || (NewProjectSteps = {}));
export const canNavigateForProjectStatus = (projectStatus, stepStatus) => {
    const normalizedProjectStatus = projectStatus?.toUpperCase();
    if (normalizedProjectStatus === "ACTIVE") {
        return true;
    }
    return normalizedProjectStatus === "PENDING" && stepStatus === IndicatorItemsStatus.complete;
};
const CreateNewProject = () => {
    const { appConfig } = useAppConfigStore((state) => ({
        appConfig: state.appConfig
    }));
    const { modeType, projectName, projectStatus } = useNewProjectStore((state) => ({
        modeType: state.modeType,
        projectName: state.projectName,
        projectStatus: state.projectStatus
    }));
    const [currentStep, setCurrentStep] = useState(NewProjectSteps.STEP_ONE);
    const setActiveStepHandler = (step) => {
        setCurrentStep(step);
    };
    const getIndicatorItemsStatus = (step) => {
        const isInitialProjectCreation = modeType === ModeType.CREATE && projectStatus === "";
        if (currentStep === step) {
            return IndicatorItemsStatus.active;
        }
        if (currentStep > step) {
            return IndicatorItemsStatus.complete;
        }
        if (currentStep < step) {
            return isInitialProjectCreation ? IndicatorItemsStatus.disabled : IndicatorItemsStatus.incomplete;
        }
        return IndicatorItemsStatus.disabled;
    };
    const canNavigateToStep = (step) => {
        return canNavigateForProjectStatus(projectStatus, getIndicatorItemsStatus(step));
    };
    const getStepNavigationProps = (step) => {
        if (!canNavigateToStep(step)) {
            return {};
        }
        return {
            onBlProgressIndicatorItemSelect: () => {
                setCurrentStep(step);
            }
        };
    };
    const getProgressIndicatorSteps = () => {
        const steps = [
            {
                dataTest: "project-details-step-1",
                fieldNote: modeType === ModeType.CREATE ? "Define project details" : "Defined project details",
                label: modeType === ModeType.CREATE ? "New Project Information" : "Project Information",
                stepNumber: NewProjectSteps.STEP_ONE
            },
            {
                dataTest: "geofence-areas-step-2",
                fieldNote: modeType === ModeType.CREATE ? "Define new geofence areas" : "Geofence Areas",
                label: modeType === ModeType.CREATE ? "Create Geofence" : "Geofence Information",
                showStepCount: !appConfig?.release_1_1?.showNewProjectAssetPortfolio,
                stepNumber: NewProjectSteps.STEP_TWO
            }
        ];
        if (appConfig?.release_1_1?.showNewProjectAssetPortfolio) {
            steps.push({
                dataTest: "assets-portfolio-step-3",
                fieldNote: "Assets Portfolio Details",
                label: modeType === ModeType.CREATE ? "Add Assets Portfolio" : "Assets Portfolio Details",
                showStepCount: true,
                stepNumber: NewProjectSteps.STEP_THREE
            });
        }
        return steps;
    };
    const getProgressIndicator = () => {
        const progressIndicatorSteps = getProgressIndicatorSteps();
        return (_jsx("div", { children: _jsx(CatProgressIndicator, { "data-test": "create-new-project-progress-indicator", children: _jsx(React.Fragment, { children: progressIndicatorSteps.map(({ dataTest, fieldNote, label, showStepCount, stepNumber }) => (_jsx(CatProgressIndicatorItem, { "data-test": dataTest, fieldNote: fieldNote, label: label, ...getStepNavigationProps(stepNumber), status: getIndicatorItemsStatus(stepNumber), stepNumber: stepNumber, children: showStepCount && (_jsx("div", { slot: "step-count", children: `${currentStep} of ${progressIndicatorSteps.length}` })) }, stepNumber))) }, ".0") }) }));
    };
    return (_jsxs("div", { className: "flex-1 flex flex-col min-h-[440px]", children: [_jsxs("div", { className: "flex items-center pl-[24px] pr-[24px] pt-[16px] pb-[16px] h-[70px] gap-[12px]  border-[#CCCCCC]border-b", "data-test": "project-name-header", children: [projectName && _jsx(_Fragment, { children: "Project Name:\u00A0" }), _jsx("div", { className: "font-headline font-bold  text-[22px] text-headline leading-headline tracking-normal", "data-test": "create-new-project-title", children: projectName ? projectName : "Create New Project" })] }), _jsx("div", { className: "mb-4", children: _jsx("hr", {}) }), _jsxs("div", { className: "flex-1 flex flex-col gap-[24px] pl-[24px] pr-[24px] ", children: [_jsx("div", { className: "h-[44px]", "data-test": "progress-indicator", children: getProgressIndicator() }), currentStep === NewProjectSteps.STEP_ONE && (_jsx(NewProjectForm, { activeStep: currentStep, "data-test": "new-project-form-step-1", setActiveStepHandler: setActiveStepHandler })), currentStep === NewProjectSteps.STEP_TWO &&
                        (appConfig?.release_1_1?.showGmapGeoFence ? (_jsx(AddEditGeoFenceForm, { activeStep: currentStep, "data-test": "new-project-geofence-areas-step-2", setActiveStepHandler: setActiveStepHandler })) : (_jsx(NewProjectAssetPortfolio, { activeStep: currentStep, "data-test": "new-project-assets-portfolio-step-2", setActiveStepHandler: setActiveStepHandler }))), currentStep === NewProjectSteps.STEP_THREE && appConfig?.release_1_1?.showNewProjectAssetPortfolio && (_jsx(NewProjectAddEditAssetsPortfolio, { activeStep: currentStep, "data-test": "new-project-assets-portfolio-step-3", setActiveStepHandler: setActiveStepHandler }))] })] }));
};
export default CreateNewProject;
